// removed by extract-text-webpack-plugin
module.exports = {"videoBoard":"_1QdYwgxfrenV5afiel619l","videoBox":"_1IrQX-1L87ok7VIwBwngRx","children":"KKiUjzeWvMJZqQhIRvz7z","icLine":"_1GEX_OnSjAXO3Yf5RdMp9y","loadingText":"_8bnQskfib01qUjndoT1-N","central":"zRKHUtfHmbvMxrUOrNacP","loadingSvg":"_3ekaPbSDHJrRSvi9PettDT","loading-logo-spin":"_15CWyFWfor-TEaqndsDFKq","playSvg":"_1QTQMAgDrd9q14qlbsvFiv","tvSvg":"goyXSHcfKM-YDs3ZrDwF5","icLineContainer":"_390amqjTxUFS2Bd2u7-xOY zRKHUtfHmbvMxrUOrNacP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoBoard/VideoBoard.css
// module id = 183
// module chunks = 0